import { z } from 'zod';

export const UpdateNotesSchema = z.object({
  notes: z.string().optional(),
  internalNotes: z.string().optional(),
});

export type UpdateNotes = z.infer<typeof UpdateNotesSchema>;
